"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@qwkin/core");
var _image = require("@qwkin/image");
var _LoadingAnimation = _interopRequireDefault(require("../LoadingAnimation/LoadingAnimation"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PDFPreview = function PDFPreview(_ref) {
  var s3Key = _ref.s3Key,
    s3Bucket = _ref.s3Bucket;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isLoading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    fileSrc = _useState4[0],
    setFileSrc = _useState4[1];
  (0, _react.useEffect)(function () {
    setLoading(true);
    _core.API.fromS3(s3Bucket, s3Key).then(function (file) {
      setFileSrc((0, _image.bufferArrToBase64)(file === null || file === void 0 ? void 0 : file.Body));
      setLoading(false);
    })["catch"](function () {
      setLoading(false);
    });
  }, [s3Key]);
  return isLoading ? /*#__PURE__*/_react["default"].createElement(_LoadingAnimation["default"], {
    color: "#000000"
  }) : /*#__PURE__*/_react["default"].createElement("iframe", {
    title: "Document",
    src: "data:application/pdf;base64,".concat(fileSrc),
    width: 480,
    height: 500
  });
};
var _default = exports["default"] = PDFPreview;